import React, { createContext, useContext, useState } from "react";

const PenaltyNotificationContext = createContext();

export const PenaltyNotificationProvider = ({ children }) => {
  const [penaltyNotification, setPenaltyNotification] = useState(0);

  return (
    <PenaltyNotificationContext.Provider value={{ penaltyNotification, setPenaltyNotification }}>
      {children}
    </PenaltyNotificationContext.Provider>
  );
};

export const usePenaltyNotification = () => useContext(PenaltyNotificationContext);
